






import { sanitizeFilename } from "../sanitizeFilename";

function formatLevelLabel(level) {
  if (!level) {
    return "";
  }
  return level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
}

function keyConceptBullets(concepts) {
  return concepts.map((concept) => `${concept.title}: ${concept.body}`);
}

function teachingFlowStepBullet(step) {
  const lines = [`${step.title} (${step.duration})`];

  if (step.body) {
    lines.push(step.body);
  }

  if (step.items) {
    for (const item of step.items) {
      lines.push(`${item.label} ${item.text}`);
    }
  }

  if (step.highlightBox) {
    lines.push(`${step.highlightBox.title}: ${step.highlightBox.body}`);
  }

  return lines.join("\n");
}

function sideInsightBullets(insight) {
  const bullets = [];

  if (insight.quote) {
    bullets.push(insight.quote);
  }

  for (const section of insight.sections) {
    bullets.push(`${section.label}: ${section.body}`);
  }

  return bullets;
}

export function teachThisTopicToPptDocument(
result)
{
  const slides = [
  {
    kind: "title",
    title: result.title,
    subtitle: result.curriculumLabel
  },
  {
    kind: "section",
    title: "Overview",
    lead: result.overview.heading,
    body: result.overview.body
  },
  {
    kind: "bullets",
    title: "Key Concepts",
    bullets: keyConceptBullets(result.keyConcepts)
  },
  {
    kind: "bullets",
    title: "Teaching Flow",
    bullets: result.teachingFlow.map(teachingFlowStepBullet)
  },
  ...result.sideInsights.map((insight) => ({
    kind: "bullets",
    title: insight.title,
    bullets: sideInsightBullets(insight)
  })),
  {
    kind: "bullets",
    title: "Quick Check",
    bullets: result.quickCheck.map(
      (column) => `${formatLevelLabel(column.level)}: ${column.question}`
    )
  },
  {
    kind: "section",
    title: result.visualizing.title,
    body: result.visualizing.subtitle
  }];


  return {
    filename: sanitizeFilename(result.title, "teaching-guide"),
    title: result.title,
    subject: result.curriculumLabel,
    author: "Tema Teach This Topic",
    slides
  };
}
